// extracted by mini-css-extract-plugin
export var tape = "tape-module--tape--1bN-Q";
export var left = "tape-module--left--3Mrul";
export var right = "tape-module--right--1GhFG";